import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import type { ObjectFieldValuesDetails } from "../../../../api/types/objectTypes";
import useClientContext from "../../../../context/useClientContext";
import ObjectDetailsPage from "../../../entityFields/ObjectDetailsPage";
import InvoiceAgent from "./InvoiceAgent";
import useInvoiceCardPreviewConfig from "./useInvoiceCardPreviewConfig";
import useInvoiceSource from "./useInvoiceSource";

interface Props {
  backButtonPath: string;
  forApproval?: boolean;
}

const renderInvoiceAgent = (objectData: ObjectFieldValuesDetails): ReactNode => (
  <InvoiceAgent key={objectData.id} invoiceId={objectData.id} invoiceUpdateAt={objectData.updateAt} />
);

const InvoiceDetailsPage = ({ backButtonPath, forApproval }: Props) => {
  const { id = "" } = useParams();
  const { isPortalFeatureEnabled } = useClientContext();
  const cardPreview = useInvoiceCardPreviewConfig();
  const { source, isLoading, hasFailed, refresh } = useInvoiceSource(id);

  if (!id) {
    return <Navigate to=".." />;
  }

  if (hasFailed) {
    return <DataLoadingFailed />;
  }

  return (
    <ObjectDetailsPage
      forApproval={forApproval}
      objectId={id}
      objectType="Invoice"
      backButtonPath={backButtonPath}
      cardPreview={cardPreview}
      source={source}
      isSourceLoading={isLoading}
      onRefresh={refresh}
      renderTopSection={
        isPortalFeatureEnabled("ExpenseManagementApprovalAgentEnabled") ? renderInvoiceAgent : undefined
      }
    />
  );
};

export default InvoiceDetailsPage;
